import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {FileItem, FileLikeObject, FileUploader} from 'ng2-file-upload';
import {ModalDirective} from 'ngx-bootstrap/modal';
//If service needed
//import { RecFileUploadService } from './recFileUpload.service';

@Component({
  selector: 'baseUploaderComponent',
  template: '',
})
export abstract class BaseUploaderComponent implements OnInit {
  @ViewChild('errorModal') public errorModal: ModalDirective;
  @ViewChild('fileUpload') fileUpload: any;

  public group = '';
  public visuals: any = {};
  public genericVisuals: any = {};
  //Uploader Constractor vars
  public URL = '';
  public uploader: FileUploader;
  public uploading: boolean = false;
  public allowedMimeType = ['text/plain'];
  public displayAllowedMimeType;
  public maxFileSize = 5 * 1024 * 1024; //5MB
  public queueLimit = 1;

  //File drop/select message
  public quequeMsg: string = '';

  //Response message
  public resultType: boolean = true;
  public resultMsg: string = '';
  public resultDetails: any = [];

  public intRegex = /(^0$)|(^[1-9]\d*$)/;

  constructor(
    public securityService: SecurityService,
    public configService: ConfigService,
    public logger: LogService,
    public visualsService: VisualsService,
    public eventsEmitterService: EventsEmitterService,
  ) {
    this.initLoader();
  }

  ngOnInit() {
    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    this.uploader.onAfterAddingFile = (item) => {
      this.quequeMsg = '';
    };

    this.uploader.onWhenAddingFileFailed = (item, filter, options) =>
      this.onWhenAddingFileFailed(item, filter, options);
  }

  public onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    this.quequeMsg = '';
    this.logger.log(filter.name);
    switch (filter.name) {
      case 'fileSize':
        this.quequeMsg = this.visuals.fileSize + this.maxFileSize / 1024 / 1024 + '(MB)';
        break;
      case 'mimeType':
        this.quequeMsg = this.visuals.mimeType + this.displayAllowedMimeType.join();
        break;
      case 'queueLimit':
        this.quequeMsg = this.visuals.queueLimit; //+ " ( Max " + this.queueLimit + " )";
        this.fileUpload.nativeElement.value = '';
        this.uploader.clearQueue();
        break;
      default:
        this.logger.log('Unknown error, filter = ' + filter.name);
        this.quequeMsg = this.visuals.uploadGenericError;
    }
  }

  public removeCustom(item: FileItem) {
    //trick to be able to remove and add the same item
    this.fileUpload.nativeElement.value = '';
    item.remove();
    this.uploader.clearQueue();
  }

  public uploadCustom(item: FileItem) {
    this.uploading = true;
    this.securityService.checkToken().subscribe({
      next: (data) => {
        this.uploader.authToken = 'Bearer ' + this.securityService.getFromStorage('access_token');
        item.upload();

        this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
          let res = JSON.parse(response);
          if (res.success) {
            this.resultType = true;
            this.resultMsg = res.message;
            this.uploading = false;

            this.uploadSuccessCallback();
          } else {
            this.resultType = false;
            this.resultMsg = res.message;
            this.logger.log(response);
            if (response) {
              if (
                /<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(response)
              ) {
                this.resultDetails = [this.visuals.uploadGenericError];
              } else {
                try {
                  let jsonResponse = JSON.parse(response);
                  this.resultDetails = jsonResponse.message;

                  LogService.emitAlert({
                    type: 'danger',
                    body: jsonResponse.message,
                  });
                  //  this.uploader.clearQueue();
                } catch (e) {
                  let jsonResponse = JSON.parse(response);
                  this.resultDetails = [jsonResponse];

                  LogService.emitAlert({
                    type: 'danger',
                    body: jsonResponse.message,
                  });
                  // this.uploader.clearQueue();
                }
              }
            } else {
              let jsonResponse = JSON.parse(response);
              this.resultDetails = jsonResponse.message;

              LogService.emitAlert({
                type: 'danger',
                body: jsonResponse.message,
              });
              // this.uploader.clearQueue();
            }
            this.uploading = false;
          }
        };
      },
      error: (error) => {
        this.uploading = false;
      },
    });
  }

  public getVisuals() {
    this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
    this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
  }

  public abstract initLoader(): void;

  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public showChildModal(): void {
    this.errorModal.show();
  }

  public hideChildModal(): void {
    this.errorModal.hide();
  }

  public uploadSuccessCallback() {}
}
